<template>
  <div v-loading="isBusy" class="wrap">
    <div class="d-flex">
      <div class="mr-auto">
        <button class="btn btn-secondary" @click="refresh"><i class="fas fa-sync-alt"></i></button>
        <slot name="buttons"></slot>
      </div>
      <div class="align-self-end">
        <input-debounced
            v-model="search"
            :clearable="true"
            :autofocus="true"
            placeholder="Search"
            class="search-bar w-300 mb-2"
        ></input-debounced>
      </div>
    </div>
    <base-table
        :base-url="urlWithFilters"
        ref="baseTable"
        @load-success="onLoadSuccess"
        @refresh="onRefresh"
        :current-page="currentPage"
        v-loading="isRefreshing"
        element-loading-spinner="el-icon-loading"
    >
      <template v-slot>
        <el-table
            :data="items"
            stripe
            class="w-100"
        >
          <el-table-column
              prop="model.id"
              label="Id"
              min-width="80"
          ></el-table-column>
          <el-table-column
              prop="model.first_name"
              label="First Name"
              min-width="100"
          ></el-table-column>
          <el-table-column
              prop="model.last_name"
              label="Last Name"
              min-width="100"
          ></el-table-column>
          <el-table-column
              prop="model.email"
              label="Email"
              min-width="150"
          ></el-table-column>
          <el-table-column
              prop="model.role.name"
              label="Role"
              min-width="100"
          ></el-table-column>
          <el-table-column
              label="Actions"
              v-slot="{row}"
          >
            <actions-column
                :row="row"
                @view="onView"
                @edit="onEdit"
                @assign-groups="onAssignGroups"
                @delete="onDelete"
                @restore="onRestore"
                @force-delete="onForceDelete"
            ></actions-column>
          </el-table-column>
        </el-table>
      </template>
    </base-table>
    <el-pagination
        layout="prev, pager, next"
        :total="total"
        :current-page.sync="currentPage"
        :page-size="pageSize"
        class="text-right"
    ></el-pagination>
  </div>
</template>

<script>
import TableWithPagination from '../table-with-pagination';
import {addQueryParams} from '../../libs/url';
import ActionsColumn from './actions-column';

export default {
  extends: TableWithPagination,

  components: {
    ActionsColumn,
  },

  data() {
    return {
      search: null,
      filters: {},
      isBusy: false,
    };
  },

  computed: {
    /**
     * @return {string}
     */
    urlWithFilters() {
      return addQueryParams(this.url, this.filters);
    },
  },

  watch: {
    search: function (value) {
      this.filters = value
          ? _.assign({}, this.filters, {search: value})
          : this.filters = _.omit(this.filters, ['search']);
    },
  },

  methods: {
    /**
     * @return {undefined}
     */
    refresh() {
      this.$refs.baseTable.refresh();
    },

    /**
     * @param {string} url
     * @return {undefined}
     */
    onView({url}) {
      window.location = url;
    },

    /**
     * @param {string} url
     * @return {undefined}
     */
    onEdit({url}) {
      window.location = url;
    },

    /**
     * @param {string} url
     * @param {string} name
     * @return {undefined}
     */
    onAssignGroups({url, name}) {
      eventBus.$emit('show-assign-user-groups-dialog', {url, name});
    },

    /**
     * @param {string} url
     * @return {undefined}
     */
    onDelete({url}) {
      this.isBusy = true;
      axios.post(url, {_method: 'DELETE'})
          .then(({data: {message}}) => {
            _.isString(message) && this.$message.success(message);
            this.refresh();
          })
          .catch((err) => {
            const message = _.get(err, 'response.data.message');
            _.isString(message) && this.$message.error(message);
          })
          .then(() => this.isBusy = false);
    },

    /**
     * @param {string} url
     * @return {undefined}
     */
    onRestore({url}) {
      this.isBusy = true;
      axios.post(url, {_method: 'POST'})
          .then(({data: {message}}) => {
            _.isString(message) && this.$message.success(message);
            this.refresh();
          })
          .catch((err) => {
            const message = _.get(err, 'response.data.message');
            _.isString(message) && this.$message.error(message);
          })
          .then(() => this.isBusy = false);
    },

    /**
     * @param {string} url
     * @return {undefined}
     */
    onForceDelete({url}) {
      this.isBusy = true;
      axios.post(url, {_method: 'DELETE'})
          .then(({data: {message}}) => {
            _.isString(message) && this.$message.success(message);
            this.refresh();
          })
          .catch((err) => {
            const message = _.get(err, 'response.data.message');
            _.isString(message) && this.$message.error(message);
          })
          .then(() => this.isBusy = false);
    },
  }
}
</script>
